import Constants from "../../base/Constants"
import Functions from "../../base/Functions"
import {
  ADD_ORDER,
  LOGOUT,
  ORDER_STATUS,
  ORDER_UPDATING,
  SET_BUSINESS,
  SET_CONNECTED,
  SET_CREDENTIALS,
  SET_EMAIL,
  SET_LAST_VENUE,
  SET_ORDERS,
  SET_SERVICE,
  SET_STOCK_LEVEL,
  SET_VENUE,
} from "./Actions"

const initialState = {
  venue: null,
  lastVenue: null,
  business: null,
  email: "",
  connected: false,
  credentials: {},
  orders: [],
  service: null,
  services: [],
}

export default function app(state = initialState, action) {
  switch (action.type) {
    case SET_SERVICE:
      const s = state.services.map(x => {
        if (x.key === action.service.key) {
          return action.service
        }
        return x
      })
      return { ...state, service: action.service, services: s }
    case SET_CREDENTIALS:
      return { ...state, credentials: action.credentials }
    case SET_BUSINESS: {
      return { ...state, business: action.business }
    }
    case SET_EMAIL:
      return { ...state, email: action.email }
    case SET_LAST_VENUE: {
      const { name, externalVenueRef, _id } = action?.venue ?? {}
      return {
        ...state,
        lastVenue: _id ? { name, externalVenueRef, _id } : null,
      }
    }
    case SET_VENUE:
      let services = []
      if (action.venue) {
        Object.values(Constants.services).forEach(x => {
          const service = {
            ...x,
            menu: Functions.populateMenuIds(action.venue.menus[x.key] ?? {}),
            ...action.venue[x.key],
          }
          services.push(service)
        })
      }
      const service = state.service
        ? services.find(x => x.key === state.service.key)
        : services[0]
      return { ...state, venue: action.venue, services, service }
    case SET_STOCK_LEVEL:
      let newMenu = [...state.menu]
      for (let category of newMenu) {
        for (let item of category.items) {
          if (item._id === action.itemId) {
            item.inStock = action.inStock
          }
        }
      }
      return Object.assign({}, state, {
        menu: newMenu,
      })
    case SET_ORDERS:
      return Object.assign({}, state, {
        orders: action.orders,
      })
    case ADD_ORDER:
      return Object.assign({}, state, {
        orders: [
          ...state.orders.filter(x => x._id !== action.order._id),
          action.order,
        ],
      })
    case ORDER_STATUS:
      return Object.assign({}, state, {
        orders: state.orders.map(order => {
          if (order._id === action.order._id) {
            return {
              ...order,
              currentStatus: action.status,
              isUpdating: false,
            }
          }
          return order
        }),
      })
    case ORDER_UPDATING:
      return {
        ...state,
        orders: state.orders.map(order => {
          if (order._id === action.order._id) {
            return { ...order, isUpdating: action.status }
          }
          return order
        }),
      }
    case LOGOUT:
      return { ...initialState, lastVenue: state.lastVenue }
    case SET_CONNECTED:
      return { ...state, connected: action.connected }
    default:
      return state
  }
}
